<script setup lang="ts">
  /**
   * Form fieldset — 03-components/15-form-inputs · OSCloud DS 1.1.34
   */
  withDefaults(
    defineProps<{
      /** Trailing disclaimer under the grouped fields. */
      note?: string
      /** Draws the group border in the invalid colour. */
      invalid?: boolean
    }>(),
    {
      note: '',
      invalid: false,
    },
  )
</script>

<template>
  <fieldset class="form-fieldset" :data-invalid="invalid || undefined">
    <slot />
    <p v-if="note" class="form-fieldset__note">{{ note }}</p>
  </fieldset>
</template>

<style scoped lang="scss">
  /* Rows stack by container query on the fieldset, not the viewport, so a row in
     a narrow sidebar form stacks on a wide screen too. */
  .form-fieldset {
    container-type: inline-size;
    display: flex;
    flex-direction: column;
    gap: var(--bf-sp-3);
    min-width: 0;
    margin: 0;
    padding: var(--bf-sp-3);
    background: var(--bf-white);
    border: 1px solid var(--bf-line);
    border-radius: var(--bf-r-lg);

    &[data-invalid] {
      border-color: var(--bf-form-invalid-hairline);
    }

    /* The row is written by the consumer inside the slot, so it is reached with :deep(). */
    :deep(.form-fieldset__row) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: var(--bf-sp-3);
      align-items: start;
    }

    &__note {
      margin: 0;
      font-family: var(--bf-font-body);
      font-size: var(--bf-fs-xs);
      color: var(--bf-fg-2);
    }
  }

  /* Two equal fields stack under 420px of fieldset width. */
  @container (max-width: 420px) {
    .form-fieldset :deep(.form-fieldset__row) {
      grid-template-columns: 1fr;
    }
  }
</style>
